/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { FormControl } from '@angular/forms';
import { nullate } from '@gh/core-util';
import { EditableCellModel } from '../state';

export function createCellFormControl(model: EditableCellModel): FormControl {
  return new FormControl(model.value, (control) => nullate(model.validate(control.value)));
}
